import React from 'react';
import { useNavigate } from 'react-router-dom';
import './VisionMission.css';
import StyledButton from './StyledButton';

const VisionMission = () => {
  const navigate = useNavigate();

  const handleFacilityNavigation = () => {
    navigate('/facility');
  };

  return (
    <div className="vision-mission-container">
      <div className="vision-mission-content">
        <div className="facility-button-container">
          <StyledButton 
            variant="primary" 
            onClick={handleFacilityNavigation}
            className="facility-nav-button"
          >
            Explore our Facilities
          </StyledButton>
        </div>
        <div className="vision-section">
          <h2 className="section-title">Our Vision</h2>
          <p className="section-description">
            To position the United States as the global leader in drone manufacturing by driving 
            innovation, strengthening national security, and fueling economic growth through advanced 
            unmanned aerial systems.
          </p>
        </div>
        
        <div className="mission-section">
          <h2 className="section-title">Our Mission</h2>
          <p className="section-description">
            We are expanding from software into hardware manufacturing, delivering advanced drone 
            solutions across defense, surveillance, agriculture, logistics, and commercial domains. With 
            27 years of proven expertise and in-house Research & Development (R&D), we are investing 
            in state-of-the-art U.S. production facilities to ensure:
          </p>
          <ul className="mission-points">
            <li>A secure and transparent supply chain</li>
            <li>The creation of high-tech American jobs</li>
            <li>The continued leadership of the U.S. in drone innovation</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VisionMission;